/* Announcement rotator */
(function(){
  var msgs = document.querySelectorAll('#rotator .msg');
  if (msgs.length < 2) return;
  var i = 0;
  setInterval(function(){
    msgs[i].classList.remove('is-active');
    i = (i + 1) % msgs.length;
    msgs[i].classList.add('is-active');
  }, 4500);
})();

/* Sticky header condense */
(function(){
  var header = document.getElementById('siteHeader'), ticking = false;
  window.addEventListener('scroll', function(){
    if (ticking) return; ticking = true;
    requestAnimationFrame(function(){
      header.classList.toggle('is-scrolled', window.scrollY > 80);
      ticking = false;
    });
  }, {passive:true});
})();

/* Desktop mega menu: hover intent + keyboard */
(function(){
  var items = document.querySelectorAll('.primary > li.has-menu');
  var closeTimer = null, openItem = null;
  function open(li){
    if (closeTimer){ clearTimeout(closeTimer); closeTimer = null; }
    if (openItem && openItem !== li) close(openItem);
    li.classList.add('is-open');
    var t = li.querySelector('.top-link'); if (t) t.setAttribute('aria-expanded','true');
    openItem = li;
  }
  function close(li){
    li.classList.remove('is-open');
    var t = li.querySelector('.top-link'); if (t) t.setAttribute('aria-expanded','false');
    if (openItem === li) openItem = null;
  }
  function scheduleClose(li){
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(function(){ close(li); }, 150);
  }
  items.forEach(function(li){
    li.addEventListener('mouseenter', function(){ open(li); });
    li.addEventListener('mouseleave', function(){ scheduleClose(li); });
    var t = li.querySelector('.top-link');
    t.addEventListener('focus', function(){ open(li); });
    li.addEventListener('focusout', function(e){ if (!li.contains(e.relatedTarget)) scheduleClose(li); });
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && openItem){
      var li = openItem, t = li.querySelector('.top-link');
      close(li); if (t) t.focus();
    }
  });
})();

/* Mobile overlay: open/close, focus trap, scroll lock, level push */
(function(){
  var nav = document.getElementById('socMobileNav');
  var scrim = document.getElementById('mScrim');
  var trigger = document.getElementById('menuTrigger');
  var closeBtn = document.getElementById('mClose');
  var back = document.getElementById('mBack');
  var lastFocus = null;

  function focusable(){
    return nav.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
  }
  function openNav(){
    lastFocus = document.activeElement;
    nav.classList.add('is-open'); scrim.classList.add('is-open');
    nav.setAttribute('aria-hidden','false'); trigger.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
    setTimeout(function(){ closeBtn.focus(); }, 60);
  }
  function closeNav(){
    nav.classList.remove('is-open'); scrim.classList.remove('is-open');
    nav.setAttribute('aria-hidden','true'); trigger.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
    nav.setAttribute('data-level','1');
    if (lastFocus) lastFocus.focus();
  }
  function setLevel(n){
    nav.setAttribute('data-level', String(n));
    var pane = document.getElementById(n === 2 ? 'mPane2' : 'mPane1');
    pane.scrollTop = 0;
    var first = pane.querySelector('a[href], button');
    if (first) setTimeout(function(){ first.focus(); }, 360);
  }

  trigger.addEventListener('click', openNav);
  closeBtn.addEventListener('click', closeNav);
  scrim.addEventListener('click', closeNav);
  back.addEventListener('click', function(){ setLevel(1); });

  // Level-1 "Shop" pushes to level 2
  nav.querySelectorAll('[data-open="shop"]').forEach(function(btn){
    btn.addEventListener('click', function(){ btn.setAttribute('aria-expanded','true'); setLevel(2); });
  });

  document.addEventListener('keydown', function(e){
    if (!nav.classList.contains('is-open')) return;
    if (e.key === 'Escape'){
      if (nav.getAttribute('data-level') === '2'){ setLevel(1); } else { closeNav(); }
    }
    if (e.key === 'Tab'){ // focus trap
      var f = Array.prototype.filter.call(focusable(), function(el){ return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    }
  });
})();

/* Desktop search overlay (optional): open with "/" or Cmd/Ctrl-K */
(function(){
  var overlay = document.getElementById('searchOverlay');
  var closeBtn = document.getElementById('searchClose');
  var input = document.getElementById('q-overlay');
  function openSearch(){ overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden','false'); setTimeout(function(){ input.focus(); }, 120); }
  function closeSearch(){ overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden','true'); }
  closeBtn.addEventListener('click', closeSearch);
  overlay.addEventListener('click', function(e){ if (e.target === overlay) closeSearch(); });
  document.addEventListener('keydown', function(e){
    var typing = /^(INPUT|TEXTAREA|SELECT)$/.test((document.activeElement||{}).tagName||'');
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
    if (!typing && (e.key === '/' || (e.key === 'k' && (e.metaKey || e.ctrlKey))) && !overlay.classList.contains('is-open')){
      e.preventDefault(); openSearch();
    }
  });
})();

/* Cart count helper: keep badge + aria label in sync (call when cart updates) */
window.setCartCount = function(n){
  var badge = document.getElementById('cartCount');
  var link = document.getElementById('cartLink');
  if (badge) badge.textContent = n;
  if (link) link.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
};